import { ComponentCommonH3 } from '@/graphql/generated/graphql';
import classNames from 'classnames';

export default function DefaultContentTemplateH3({
  component,
  className,
  isDefaultContentTemplate = false,
}: {
  component: ComponentCommonH3;
  className?: string;
  isDefaultContentTemplate?: boolean;
}) {
  return (
    <h3
      key={component.id}
      className={classNames('text-sh-24 font-bold', className, {
        'my-0': isDefaultContentTemplate,
        'my-sh-20': !isDefaultContentTemplate,
      })}>
      {component.text}
    </h3>
  );
}
